import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=13d624a3&scoped=true&"
import script from "./specification.js?vue&type=script&lang=js&"
export * from "./specification.js?vue&type=script&lang=js&"
import style0 from "./specification.vue?vue&type=style&index=0&id=13d624a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d624a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d624a3')) {
      api.createRecord('13d624a3', component.options)
    } else {
      api.reload('13d624a3', component.options)
    }
    module.hot.accept("./specification.vue?vue&type=template&id=13d624a3&scoped=true&", function () {
      api.rerender('13d624a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cart/components/specification/specification.vue"
export default component.exports